module.exports = __webpack_public_path__ + "static/img/friend3.7e6abd4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/friend3.png
// module id = M0YJ
// module chunks = 1